import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../css/partner/OnboardingWelcome.css";

export default function OnboardingWelcome() {
  const navigate = useNavigate();

  return (
    <div className="onboarding-welcome">
      <h1>Welcome to the South Central Development Partner Program</h1>

      <p className="lead mt-4">
        Thank you for joining our Partner Program.
      </p>

      <p>
        Our mission is simple: help businesses grow through professional
        websites and digital solutions.
      </p>

      <p>
        As a Partner, your role is to build relationships with business owners
        and introduce them to our services.
      </p>

      <p>
        You focus on finding opportunities. We handle the technical work,
        including design, development, hosting, and project delivery.
      </p>

      <p>
        This opportunity is ideal for people who enjoy networking, building
        relationships, and helping businesses succeed.
      </p>

      <div className="actions">
        <button
          className="btn btn-primary"
          onClick={() => navigate("/onboarding/role")}
        >
          Continue
        </button>
      </div>
    </div>
  );
}